module.exports = __webpack_public_path__ + "static/img/华为 HUAWEI MateBook X Pro.bdf65e93.png";